import React, { Component } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import DRNText from '../../standard/Text/DRNText';
import DRNTouchableWrapper from '../../standard/Button/TouchableButtonWrapper';
import PropTypes from 'prop-types';
import R from '../../core-res/R';
import { withTheme } from '../../theme';
import { DRNUtil, DRNDateUtil } from '@traveloka/district-util';
const DATE_CELL_HEIGHT = 35;
const EXTRA_COMPONENT_HEIGHT = 12;
export const TOTAL_HEIGHT = DATE_CELL_HEIGHT + 2 * EXTRA_COMPONENT_HEIGHT;
class DRNDateCell extends Component {
    constructor() {
        super(...arguments);
        this.getDateContainerStyle = () => {
            const { marking } = this.props;
            if (!marking.color || marking.startingDay || marking.endingDay || marking.selected)
                return;
            return {
                backgroundColor: marking.color,
            };
        };
        this.getTextStyle = () => {
            const { marking, theme, disabled, isHoliday } = this.props;
            if (disabled || marking.disabled)
                return { color: theme.textMuted };
            if (isHoliday)
                return { color: theme.textAlert };
            if (!marking.color || marking.startingDay || marking.endingDay || marking.selected)
                return;
            return {
                color: theme.lightPrimary,
            };
        };
        this.getCellWidth = () => {
            const { calendarWidth } = this.props;
            return (calendarWidth - 20) / 7;
        };
        this.getDateWrapperStyle = () => {
            const { marking, theme } = this.props;
            const style = {
                backgroundColor: theme.lightPrimary,
                paddingHorizontal: R.spacing.xs,
                height: DATE_CELL_HEIGHT,
                alignItems: 'center',
                justifyContent: 'center',
            };
            const cellWidth = this.getCellWidth();
            if (marking.startingDay || marking.endingDay || marking.selected) {
                return Object.assign({}, style, { borderColor: marking.color, borderWidth: 4, borderRadius: cellWidth / 2, width: cellWidth - 4 });
            }
            return;
        };
        this.getInnerWrapperStyle = () => {
            const { theme, date } = this.props;
            if (!DRNDateUtil.isToday(new Date(date)))
                return;
            return {
                borderColor: theme.tintPrimary,
                borderBottomWidth: R.border.width.bold,
            };
        };
        this.getDay = date => {
            const dateObj = new Date(date);
            return dateObj.getDate();
        };
        this.handleOnPress = () => {
            const { date, onDayPress, disabled } = this.props;
            if (disabled)
                return;
            onDayPress && onDayPress(date);
        };
        this.renderBackgroundView = () => {
            const { marking } = this.props;
            if (!marking.startingDay && !marking.endingDay)
                return;
            const style = marking.startingDay ? { right: 0 } : { left: 0 };
            return (<View style={[styles.backgroundView, { backgroundColor: marking.color, width: this.getCellWidth() / 2 }, style]}/>);
        };
    }
    render() {
        const { date, renderTopComponent, renderBottomComponent, disabled, style, accessibilityLabel } = this.props;
        return (<DRNTouchableWrapper isFeedbackEnabled={!disabled} onPress={this.handleOnPress} accessible={Platform.OS !== 'ios'}>
        <View style={[styles.container, style, { width: this.getCellWidth() }]}>
          <View style={styles.extraComponent}>{renderTopComponent && renderTopComponent(date)}</View>
          <View style={[styles.dateContainer, this.getDateContainerStyle()]}>
            <View style={this.getDateWrapperStyle()}>
              <View style={this.getInnerWrapperStyle()}>
                <DRNText {...(Platform.OS === 'ios' ? { testID: accessibilityLabel } : { accessibilityLabel })} style={[styles.dateText, this.getTextStyle()]}>
                  {this.getDay(date)}
                </DRNText>
              </View>
            </View>
            {this.renderBackgroundView()}
          </View>
          <View style={styles.extraComponent}>{renderBottomComponent && renderBottomComponent(date)}</View>
        </View>
      </DRNTouchableWrapper>);
    }
}
DRNDateCell.propTypes = {
    accessibilityLabel: PropTypes.string,
    //format: YYYY-MM-DD
    date: PropTypes.string.isRequired,
    onDayPress: PropTypes.func,
    //see marking format in https://github.com/wix/react-native-calendars
    marking: PropTypes.any,
    renderTopComponent: PropTypes.func,
    renderBottomComponent: PropTypes.func,
    disabled: PropTypes.bool,
    style: PropTypes.object,
    isHoliday: PropTypes.bool,
    calendarWidth: PropTypes.number,
    theme: PropTypes.object,
};
DRNDateCell.defaultProps = {
    marking: {},
    disabled: false,
    isHoliday: false,
    calendarWidth: DRNUtil.getScreenWidth(),
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        height: TOTAL_HEIGHT,
    },
    dateContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        width: '100%',
        height: DATE_CELL_HEIGHT,
    },
    dateText: {
        fontFamily: R.typography.weightRegular.fontFamily,
    },
    backgroundView: {
        height: DATE_CELL_HEIGHT,
        position: 'absolute',
        zIndex: -1,
    },
    extraComponent: {
        height: EXTRA_COMPONENT_HEIGHT,
    },
});
export default withTheme(DRNDateCell);
